
import React from 'react';

interface LoadingSpinnerProps {
    message?: string;
    size?: 'small' | 'medium' | 'large';
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ message = "Loading...", size = 'medium' }) => {
    const sizeClasses = {
        small: 'h-8 w-8 border-b-2 border-t-2',
        medium: 'h-12 w-12 border-b-4 border-t-4',
        large: 'h-16 w-16 border-b-4 border-t-4',
    };

    return (
        <div className="flex flex-col items-center justify-center py-6 text-center">
            <div
                className={`animate-spin rounded-full ${sizeClasses[size]} border-blue-500 mb-3`}
                role="status"
                aria-label="Loading"
            ></div>
            <p className="text-md font-semibold text-slate-400">{message}</p>
        </div>
    );
};

export default LoadingSpinner;
